import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "cta",
  label: "Call to Action",
  description: "A full-width picture banner with a link, and optional text on a mint band.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Picture banner",
      fields: [
        { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 200 px; may carry its own artwork." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 340 px." },
        { key: "link", label: "Link", type: "string", default: "/contact" },
        { key: "title", label: "Heading (optional)", type: "string", default: "Become a reseller" },
        { key: "subtitle", label: "Line (optional)", type: "string", default: "Sell our clothes and earn on every order." },
        { key: "buttonText", label: "Button text (optional)", type: "string", default: "Join now" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
